export const LISTING_ASSETS_LIST = "LISTING_ASSETS_LIST";
export const LISTING_SINGLE_ASSET = "LISTING_SINGLE_ASSET";
export const LISTING_SUCCESS = "LISTING_SUCCESS";
export const LISTING_CREATING_ASSET = "LISTING_CREATING_ASSET";
export const LISTING_CREATING_ASSET_START = "LISTING_CREATING_ASSET_START";
export const LISTING_UPDATING_ASSET = "LISTING_UPDATING_ASSET";
export const LISTING_UPDATING_ASSET_START = "LISTING_UPDATING_ASSET_START";
export const LISTING_DELETING_ASSET = "LISTING_DELETING_ASSET";
export const LISTING_ASSET_ERROR = "LISTING_ASSET_ERROR";
export const LISTING_ASSET_RESET_ERROR = "LISTING_ASSET_RESET_ERROR";
export const SELECT_ALL_ASSETS_DATA = "SELECT_ALL_ASSETS_DATA";
export const ASSIGN_UPDATING_ASSET = "ASSIGN_UPDATING_ASSET";
export const ASSIGN_UPDATING_ASSET_ERROR = "ASSIGN_UPDATING_ASSET_ERROR";
export const SELECT_ALL_STAKING_RISK_DATA = "SELECT_ALL_STAKING_RISK_DATA";
export const ASSIGN_UPDATING_STAKING_RISK_TO_USER =
  "ASSIGN_UPDATING_STAKING_RISK_TO_USER";
export const ASSIGN_UPDATING_STAKING_RISK_TO_USER_ERROR =
  "ASSIGN_UPDATING_STAKING_RISK_TO_USER_ERROR";

const listingInitialState = {
  assetsList: [],
  userStakingRiskList: [],
  userAssetsList: [],
  singleAsset: [],
  created: false,
  creating: false,
  updating: false,
  updated: false,
  deleted: false,
  singleAssetErrors: "",
  assignAssetsUpdated: false,
  assignStakingRiskUpdated: false,
  userAssetsUpdatedError: "",
};

export function ListingAssetsReducer(
  state = listingInitialState,
  { payload, type },
) {
  switch (type) {
    case SELECT_ALL_STAKING_RISK_DATA:
      return {
        ...state,
        userStakingRiskList: payload.data,
        created: false,
        updated: false,
        deleted: false,
      };
    case SELECT_ALL_ASSETS_DATA:
      return {
        ...state,
        userAssetsList: payload.data,
        created: false,
        updated: false,
        deleted: false,
      };
    case ASSIGN_UPDATING_ASSET:
      return {
        ...state,
        assignAssetsUpdated: true,
      };
    case ASSIGN_UPDATING_STAKING_RISK_TO_USER:
      return {
        ...state,
        assignStakingRiskUpdated: true,
      };
    case ASSIGN_UPDATING_ASSET_ERROR:
      return {
        ...state,
        userAssetsUpdatedError: payload?.errors,
      };
    case LISTING_ASSETS_LIST:
      return {
        ...state,
        assetsList: payload.result,
        created: false,
        updated: false,
        deleted: false,
      };
    case LISTING_SINGLE_ASSET:
      return {
        ...state,
        singleAsset: payload.result,
      };
    case LISTING_CREATING_ASSET_START:
      return {
        ...state,
        creating: true,
        created: false,
        singleAssetErrors: "",
      };
    case LISTING_CREATING_ASSET:
      return {
        ...state,
        created: true,
        creating: false,
      };
    case LISTING_UPDATING_ASSET_START:
      return {
        ...state,
        updating: true,
        updated: false,
        singleAssetErrors: "",
      };
    case LISTING_UPDATING_ASSET:
      return {
        ...state,
        updated: true,
        updating: false,
      };
    case LISTING_DELETING_ASSET:
      return {
        ...state,
        deleted: true,
      };
    case LISTING_ASSET_ERROR:
      return {
        ...state,
        creating: false,
        updating: false,
        singleAssetErrors: payload?.errors,
      };
    case LISTING_ASSET_RESET_ERROR:
      return {
        ...state,
        singleAssetErrors: "",
      };
    default:
      return state;
  }
}
